/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Reviewers_Users_LabelInputs */



/**
* | output |
* | --- |
* | "Reviewers (users)" |
*
* @param {Iconik_Publish_Reviewers_Users_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_reviewers_users_label = /** @type {((inputs?: Iconik_Publish_Reviewers_Users_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Reviewers_Users_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reviewers (users)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reviewers (users)")
	return /** @type {LocalizedString} */ ("Reviewers (users)")
});